export const addWord = {
  // 유효성 검사
  loginRequired: '로그인이 필요합니다',
  required: '단어와 의미는 필수입니다',
  submitFailed: '등록에 실패했습니다. 다시 시도해 주세요.',

  // 등록 완료
  doneTitle: '등록 완료!',
  doneBody: '등록한 내용은 Admin 승인 후에 공개됩니다.<br />잠시만 기다려 주세요.',
  continuePosting: '계속 등록',
  toWordPool: 'Word Pool로',

  // 헤더
  back: '← Back to Word Pool',
  heading: '단어 등록하기',
  poster: '등록자: ',

  // 라벨
  languageLabel: '언어 *',
  phraseLabel: '단어 / 문구 *',
  phrasePlaceholder: '예: 오츠카레사마',
  readingLabel: '읽는 법 / 발음',
  readingPlaceholder: '예: Otsukaresama',
  meaningLabel: '의미 (영어) *',
  meaningPlaceholder: '예: Good work today / Thank you for your effort',
  usageLabel: '사용법 / 맥락',
  usagePlaceholder: '어떤 상황에서 사용하나요?',
  lessonDateLabel: '레슨 날짜',

  // 등록
  submitting: '등록 중...',
  submit: '등록하기',
  note: '※ 등록 후 Admin 승인을 거쳐 공개됩니다',
};
